// teste pipeline

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function setMinibanner() {
  const minibanners = document.querySelectorAll('[data-minibanner]');

  minibanners.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    const newMinibanner = new Swiper(carousel, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 2, // Default para mobile
      watchOverflow: true,
      speed: 1000,
      loop: true,
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        // A partir de 768px (tablet) - 4 slides
        768: {
          slidesPerView: 6,
        },
        // A partir de 992px (desktop) - mantém 4 slides + navegação
        992: {
          slidesPerView: 6,
          navigation: {
            nextEl: next,
            prevEl: prev,
            disabledClass: '-disabled',
          },
        },
      },
    });

    // Autoplay condicional
    newMinibanner.autoplay.stop();

    const eventType = window.mobile ? 'scroll' : 'mousemove';
    window.addEventListener(eventType, newMinibanner.autoplay.start, { once: true });
  });
}